import React from "react";
import { Container, Row, Col } from "reactstrap";
import CodeSnippet from "../index-sections/CodeSnippet.js";

function Installazione() {
  return (
    <>
      <div className="section section-dark">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="8">
                <h2 className="title">Installazione</h2>
                <p className="description">
                    Per installare Node.js sul proprio computer è sufficente scaricare il file di installazione dal sito ufficile di Node.js <a href="https://nodejs.org/en/download" target="new">(SCARICA QUI)</a> ed avviare la procedura guidata di installazione.
                </p>
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="bash"
                description="Per verificare la corretta installazione è possibile eseguire questi 2 comandi"
                code={`node --version
npm --version`}
            />
            {/* Fine snippet del codice */}    
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Installazione;
